// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__RnvNR","noHeader":"styles_noHeader__8NqrH"};